// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1HZqu","title":"ClientCherryInfo_title__2_23g","itemText":"ClientCherryInfo_itemText__1OMsg"};